import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-thank-you',
  templateUrl: './thank-you.component.html',
  styleUrls: ['./thank-you.component.scss']
})
export class ThankYouComponent implements OnInit {
  projectDetail:any;
  constructor() { }

  ngOnInit() {
    this.projectDetail = JSON.parse(localStorage.getItem("full_project")) || "noemail";
    
  }

}
